<template>
 <el-form label-width="" ref="ruleForm"  :rules="rules" :model="item">
  <el-col :span="20">

  <el-col :span="15">
    <el-form-item  prop="fileDesc">
      <el-input
        placeholder="请输入协议文件描述"
        v-model="item.fileDesc">
      </el-input>
    </el-form-item>
  </el-col>

  <el-col :span="8">
    <el-form-item  prop="fileList">
        <el-upload
            ref="upload"
            name="file"
            action="bb"
            :before-remove="handleRemove"
            :on-change="handleChange"
            :auto-upload="false"
            :file-list="item.fileList">
          <el-button icon="el-icon-upload2">上传文件</el-button>
      </el-upload>
    </el-form-item>
  </el-col>
  <el-col :span="1">
    <div v-if="uploadFileList && uploadFileList.length > 0" class="el-icon-delete-solid" @click="remove"></div>
  </el-col>
    <el-col>
      <div v-if="item.fileList.length === 0" class="tip">支持扩展名.rar .zip .doc .docx .pdf .jpg.....</div>
    </el-col>
  </el-col>
 </el-form>
</template>
<script>
import eventBus from '@/assets/js/eventBus'
import { previewFileUpload } from '@/api/fileServer'
export default {
  props: {
    index: {
      type: Number
    },
    uploadFileList: {
      type: Array
    },
    item: {
      type: Object
    }
  },
  data () {
    const fileListValidate = (rule, value, callback) => {
      if (this.item.fileList.length === 0) {
        callback(new Error('请上传文件'))
      } else {
        callback()
      }
    }
    const fileDescValidate = (rule, value, callback) => {
      const num = this.item.fileDesc
      if (num.length > 20) {
        callback(new Error('请输入20字以内的描述'))
      } else {
        callback()
      }
    }
    return {
      // form: {
      //   fileList: [],
      //   fileName: ''
      // },
      rules: {
        fileDesc: [
          { required: true, message: '请输入协议文件描述', trigger: 'change' },
          { validator: fileDescValidate, trigger: 'change' }
        ],
        fileList: [
          { validator: fileListValidate, trigger: 'change' }
        ]
      }
    }
  },
  created () {
    eventBus.$on('validateFileList', this.validateFileList)// 验证表单
    eventBus.$on('resetFields', this.resetFields)// 重置表单
  },
  methods: {
    resetFields () {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },
    validateFileList () {
      this.uploadFileList[this.index] ? this.uploadFileList[this.index].validate = false : ''
      this.$refs.ruleForm && this.$refs.ruleForm.validate(valid => {
        if (valid && this.uploadFileList[this.index]) {
          this.uploadFileList[this.index].validate = true
        }
      })
    },
    remove () {
      eventBus.$emit('addDelImg', [this.item.fileToken])
      this.uploadFileList.splice(this.index, 1)
      // 当编辑中的协议文件被全部删除后，发射事件，让下载按钮消失
      if (this.uploadFileList.length === 0) {
        eventBus.$emit('removeAgreement')
      }
    },
    handleChange (file, fileList) {
      eventBus.$emit('addDelImg', [this.item.fileToken])
      console.log('file:', file)
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('dir', 'product/file/')
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      previewFileUpload(formData).then(res => {
        if (res.status === 200) {
          res = res.data
          this.item.fileList.splice(0, this.item.fileList.length, ...fileList)
          // 赋值给fileName和fileToken
          this.item.fileName = file.name
          this.item.fileToken = res.data.pathKey
          this.$refs.ruleForm.clearValidate()// 清除表单校验信息
        } else {
          this.item.fileList.splice(0, 1)// 上传不成功清空
        }
      }, res => {
        this.item.fileList.splice(0, 1)// 上传出错清空
      })
    },
    handleRemove () {
      eventBus.$emit('addDelImg', [this.item.fileToken])
      this.item.fileList.splice(0)
    }
  }
}
</script>
<style lang='less' scoped>
.el-icon-delete-solid{
  color: #b2b3b7;
}
.tip{
  color:#b2b3b7;
  margin-top:10px
}
.avatar-uploader-icon {
     font-size: 14px;
    color:white;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color:#409EFF;
    border-radius: 25px;
    cursor: pointer;
  }
  .el-button{
    margin-left: 10px;
  }
  .el-icon-delete-solid{
    font-size: 20px;
    cursor: pointer;
  }
</style>
